/* ================================================
   The Beau PMU Studio — Shopify Theme JS
   Hyper Vision Co.
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {
  initPromoBanner();
  initNavScroll();
  initHamburger();
  initServiceTabs();
  initFaqAccordion();
  initScrollReveal();
  initGalleryLightbox();
  initHeroCarousel();
  initGalleryCarousels();
  initBAVideos();
  initHeroParallax();
  initStatsCounter();
});

/* ── Hero Carousel ── */
function initHeroCarousel() {
  var carousel = document.getElementById('heroCarousel');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('.hero__slide');
  if (slides.length <= 1) return;

  var dots = document.querySelectorAll('.hero__dot');
  var prevBtn = document.getElementById('heroPrev');
  var nextBtn = document.getElementById('heroNext');
  var current = 0;
  var autoplay = carousel.dataset.autoplay !== 'false';
  var speed = (parseInt(carousel.dataset.speed) || 5) * 1000;
  var timer = null;

  function goTo(n) {
    slides[current].classList.remove('hero__slide--active');
    if (dots[current]) dots[current].classList.remove('hero__dot--active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('hero__slide--active');
    if (dots[current]) dots[current].classList.add('hero__dot--active');
  }

  function startTimer() {
    if (!autoplay) return;
    clearInterval(timer);
    timer = setInterval(function() { goTo(current + 1); }, speed);
  }

  function pause() { clearInterval(timer); }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(dot.dataset.slide));
      pause(); startTimer();
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); pause(); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); pause(); startTimer(); });

  // Touch/swipe support
  var touchStartX = 0;
  carousel.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', function(e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
      pause(); startTimer();
    }
  });

  // Pause on hover (desktop)
  carousel.addEventListener('mouseenter', pause);
  carousel.addEventListener('mouseleave', startTimer);

  startTimer();
}

/* ── Promo Banner ── */
function initPromoBanner() {
  var bar = document.getElementById('promoBar');
  var closeBtn = document.getElementById('promoClose');
  if (!bar || !closeBtn) return;

  var KEY = 'thebeau_promo_dismissed';

  function applyHeight() {
    document.documentElement.style.setProperty('--promo-h', bar.offsetHeight + 'px');
    document.body.classList.add('promo-visible');
  }

  if (!sessionStorage.getItem(KEY)) {
    applyHeight();
    window.addEventListener('resize', applyHeight);
  } else {
    bar.classList.add('dismissed');
  }

  closeBtn.addEventListener('click', function () {
    bar.classList.add('dismissed');
    document.body.classList.remove('promo-visible');
    sessionStorage.setItem(KEY, '1');
  });
}

/* ── Nav scroll effect ── */
function initNavScroll() {
  var nav = document.getElementById('nav');
  if (!nav) return;

  function update() {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  }
  update();

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () { update(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
}

/* ── Mobile hamburger ── */
function initHamburger() {
  var hamburger = document.getElementById('hamburger');
  var navLinks = document.getElementById('navLinks');
  if (!hamburger || !navLinks) return;

  function closeMenu() {
    hamburger.classList.remove('active');
    navLinks.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = navLinks.classList.contains('open');
    hamburger.classList.toggle('active');
    navLinks.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', String(!isOpen));
    document.body.style.overflow = isOpen ? '' : 'hidden';
  });

  navLinks.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });

  // Close on tap outside the nav panel
  document.addEventListener('click', function (e) {
    if (navLinks.classList.contains('open') && !navLinks.contains(e.target) && !hamburger.contains(e.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
}

/* ── Service tabs ── */
function initServiceTabs() {
  var tabs = document.querySelectorAll('.services__tab');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      var target = tab.dataset.tab;
      document.querySelectorAll('.services__category').forEach(function (cat) {
        cat.classList.toggle('active', cat.dataset.category === target);
      });
    });
  });
}

/* ── FAQ accordion ── */
function initFaqAccordion() {
  document.querySelectorAll('.faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var wasOpen = item.classList.contains('open');

      document.querySelectorAll('.faq__item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ── Scroll reveal ── */
function initScrollReveal() {
  var elements = document.querySelectorAll('.reveal');
  if (!elements.length) return;

  if (!('IntersectionObserver' in window)) {
    elements.forEach(function (el) { el.classList.add('visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  elements.forEach(function (el) { observer.observe(el); });
}

/* ── Gallery lightbox ── */
function initGalleryLightbox() {
  var lightbox = document.getElementById('lightbox');
  var lightboxImg = document.getElementById('lightboxImg');
  var lightboxCaption = document.getElementById('lightboxCaption');
  var lightboxClose = document.getElementById('lightboxClose');
  if (!lightbox) return;

  function open(src, label) {
    lightboxImg.src = src;
    lightboxImg.alt = label || '';
    if (lightboxCaption) lightboxCaption.textContent = label || '';
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (lightboxClose) lightboxClose.focus();
  }

  function close() {
    lightbox.classList.remove('active');
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.masonry__item, .gallery__cell').forEach(function (item) {
    item.setAttribute('role', 'button');
    item.setAttribute('tabindex', '0');
    item.addEventListener('click', function () {
      open(item.dataset.src || item.querySelector('img').src, item.dataset.label || '');
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open(item.dataset.src || item.querySelector('img').src, item.dataset.label || '');
      }
    });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', close);
  lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('active')) close();
  });
}

/* ── Before & After videos ── */
function initBAVideos() {
  var figures = document.querySelectorAll('.ba-video');
  if (!figures.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  figures.forEach(function (fig) {
    var video = fig.querySelector('.ba-video__player');
    var toggle = fig.querySelector('.ba-video__toggle');
    if (!video) return;

    // iOS Safari: set imperatively, don't trust markup attrs alone
    video.setAttribute('webkit-playsinline', 'true');
    video.muted = true;
    video.defaultMuted = true;

    function setPaused(paused) {
      fig.classList.toggle('ba-video--paused', paused);
      if (toggle) toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    function tryPlay() {
      video.play().then(function () { setPaused(false); }).catch(function () {
        setPaused(true);
        var resume = function () { video.play().then(function () { setPaused(false); }).catch(function () {}); };
        ['touchstart', 'scroll', 'click'].forEach(function (ev) {
          window.addEventListener(ev, resume, { once: true, passive: true });
        });
      });
    }

    if (reduced) {
      setPaused(true);
    } else {
      tryPlay();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) { video.play().catch(function () {}); setPaused(false); }
        else { video.pause(); setPaused(true); }
      });
    }
  });
}

/* ── Gallery 2x2 Carousel ── */
function initGalleryCarousels() {
  document.querySelectorAll('.gallery-carousel').forEach(function(carousel) {
    var pages = carousel.querySelectorAll('.gallery-carousel__page');
    var dots = carousel.querySelectorAll('.gallery-carousel__dot');
    var prevBtn = carousel.querySelector('.gallery-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.gallery-carousel__arrow--next');
    if (pages.length <= 1) return;

    var current = 0;

    function goTo(n) {
      pages[current].classList.remove('gallery-carousel__page--active');
      if (dots[current]) dots[current].classList.remove('gallery-carousel__dot--active');
      current = (n + pages.length) % pages.length;
      pages[current].classList.add('gallery-carousel__page--active');
      if (dots[current]) dots[current].classList.add('gallery-carousel__dot--active');
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.page)); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Touch swipe
    var touchStartX = 0;
    carousel.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    });
  });
}

/* ── Hero Parallax ── */
function initHeroParallax() {
  var hero = document.querySelector('.hero');
  if (!hero) return;
  var bgMobile = hero.querySelector('.hero__bg-mobile img');
  var bgDesktop = hero.querySelector('.hero__bg-desktop img');
  // Only on desktop, skip if reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var scrollY = window.scrollY;
      var heroH = hero.offsetHeight;
      if (scrollY < heroH) {
        var offset = scrollY * 0.3;
        var scale = 1 + scrollY * 0.0003;
        var style = 'translate3d(0,' + offset + 'px,0) scale(' + scale + ')';
        if (bgMobile) bgMobile.style.transform = style;
        if (bgDesktop) bgDesktop.style.transform = style;
      }
      ticking = false;
    });
  }, { passive: true });
}

/* ── Stats Counter Animation ── */
function initStatsCounter() {
  var items = document.querySelectorAll('.stats__number');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) return;

  function animateNumber(el) {
    var text = el.textContent.trim();
    // Extract number, prefix, suffix (e.g. "5,000+" -> num=5000, suffix="+", has comma)
    var match = text.match(/^([^\d]*)([0-9,]+(?:\.\d+)?)(.*)$/);
    if (!match) return;
    var prefix = match[1];
    var numStr = match[2];
    var suffix = match[3];
    var hasComma = numStr.indexOf(',') !== -1;
    var hasDecimal = numStr.indexOf('.') !== -1;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;

    var duration = 1600;
    var start = performance.now();

    function step(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;

      if (hasDecimal) {
        current = current.toFixed(1);
      } else {
        current = Math.round(current);
      }

      var display = String(current);
      if (hasComma && !hasDecimal) {
        display = Number(current).toLocaleString('en-US');
      }

      el.textContent = prefix + display + suffix;

      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var numbers = entry.target.querySelectorAll('.stats__number');
        numbers.forEach(function(el, i) {
          setTimeout(function() { animateNumber(el); }, i * 150);
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  var statsSection = document.querySelector('.stats');
  if (statsSection) observer.observe(statsSection);
}

/* ═══ EN/KR language toggle (HV) ═══════════════════════════════════════ */
(function () {
  var KEY = 'beau_lang';
  function apply(lang) {
    var ko = lang === 'ko';
    document.documentElement.classList.toggle('lang-ko', ko);
    document.documentElement.lang = ko ? 'ko' : 'en';
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  apply(saved === 'ko' ? 'ko' : 'en');
  document.addEventListener('click', function (e) {
    var target = e.target;
    var opt = target.closest ? target.closest('.lang-toggle__option') : null;
    var btn = target.closest ? target.closest('#langToggle, .lang-toggle') : null;
    if (!opt && !btn) return;
    var next = (opt && opt.getAttribute('data-lang'))
      ? opt.getAttribute('data-lang')
      : (document.documentElement.classList.contains('lang-ko') ? 'en' : 'ko');
    apply(next);
    try { localStorage.setItem(KEY, next); } catch (e) {}
  });
})();
